<template>
    <div class="layout">
        <h3 class="title-bar clearfix">
            <span>{{$t('processInspectionSearch.t21')}}</span>
            <Button type="primary" style="margin-left: 10px;" @click="reportSubmit" :loading="loading" v-if="!readOnly">{{ $t('processInspectionSearch.t19') }}</Button>
            <Button type="default" style="margin-left: 10px;" @click="back" :loading="loading">{{ $t('processInspectionSearch.t20') }}</Button>
        </h3>
        <div style="padding: 10px 20px;">
            <custom-panel name="1" :gutter="false">
                {{$t('processInspectionSearch.t21')}}
                <div slot="content">
                    <div style="background:#FFF;padding:10px 20px 10px 0;">
                        <Form :label-width="85" :model="reportObj" ref="reportForm" :rules="reportRules">
                            <Row>
                                <Col :span="6">
                                    <!--检验单号-->
                                    <FormItem :label="$t('processInspectionSearch.t15')">
                                        <Input type="text" disabled v-model="reportObj.reportNumber" :title="reportObj.reportNumber"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--库存组织-->
                                    <FormItem :label="$t('processInspectionSearch.t13')">
                                        <Input type="text" disabled v-model="reportObj.orgCode" :title="reportObj.orgCode"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--供方名称-->
                                    <FormItem :label="$t('processInspectionSearch.t22')">
                                        <Input type="text" disabled v-model="reportObj.supplierDesc" :title="reportObj.supplierDesc"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--采购单号-->
                                    <FormItem :label="$t('processInspectionSearch.t2')">
                                        <Input type="text" disabled v-model="reportObj.poInfos" :title="reportObj.poInfos"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--物料编码-->
                                    <FormItem :label="$t('processInspectionSearch.t4')">
                                        <Input type="text" disabled v-model="reportObj.itemCode" :title="reportObj.itemCode"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--物料描述-->
                                    <FormItem :label="$t('processInspectionSearch.t5')">
                                        <Input type="text" disabled v-model="reportObj.itemDesc" :title="reportObj.itemDesc"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--检验数量-->
                                    <FormItem :label="$t('processInspectionSearch.t23')">
                                        <Input type="text" disabled v-model="reportObj.checkCount" :title="reportObj.checkCount"/>
                                    </FormItem>
                                </Col>
                                <!--采购行号-->
                                <!-- <Col :span="6">
                                    <FormItem :label="$t('processInspectionSearch.t24')">
                                        <Input type="text" disabled v-model="reportObj.poLineIds" :title="reportObj.poLineIds"/>
                                    </FormItem>
                                </Col> -->
                                <Col :span="6">
                                    <!--通用标准版本-->
                                    <FormItem :label="$t('processInspectionSearch.t25')">
                                        <Input type="text" disabled v-model="reportObj.commonStandardsName" :title="reportObj.commonStandardsName"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--特殊标准版本-->
                                    <FormItem :label="$t('processInspectionSearch.t26')">
                                        <Input type="text" disabled v-model="reportObj.specialStandardsName" :title="reportObj.specialStandardsName"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--检验水平-->
                                    <FormItem :label="$t('processInspectionSearch.t27')">
                                        <Input type="text" disabled v-model="reportObj.inspectionLevel" :title="reportObj.inspectionLevel"/>
                                    </FormItem>
                                </Col>
                                <!--需求日期-->
                                <!-- <Col :span="6">
                                    <FormItem :label="$t('processInspectionSearch.t28')">
                                        <Input type="text" disabled v-model="reportObj.needbyDate" :title="reportObj.needbyDate"/>
                                    </FormItem>
                                </Col> -->
                                <Col :span="6">
                                    <!--一次性采购-->
                                    <FormItem :label="$t('processInspectionSearch.t29')">
                                        <Input type="text" disabled v-model="reportObj.onetimePurchaseFlagTl" :title="reportObj.onetimePurchaseFlagTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--试验品-->
                                    <FormItem :label="$t('processInspectionSearch.t30')">
                                        <Input type="text" disabled v-model="reportObj.trialFlagTl" :title="reportObj.trialFlagTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--固定样本-->
                                    <FormItem :label="$t('processInspectionSearch.t31')">
                                        <Input type="text" disabled v-model="reportObj.sampleQty" :title="reportObj.sampleQty"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--严格度-->
                                    <FormItem :label="$t('processInspectionSearch.t32')">
                                        <Input type="text" disabled v-model="reportObj.examinedStringency" :title="reportObj.examinedStringency"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--检验员-->
                                    <FormItem required :label="$t('processInspectionSearch.t11')" prop="checker">
                                        <Input type="text" :disabled="readOnly" v-model="reportObj.checker" :title="reportObj.checker"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--批次号-->
                                    <FormItem required :label="$t('processInspectionSearch.t33')" prop="batchNumber">
                                        <Input type="text" :disabled="readOnly" v-model="reportObj.batchNumber" :title="reportObj.batchNumber"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--产地-品牌-->
                                    <FormItem required :label="$t('processInspectionSearch.t34')" prop="originPlace">
                                        <Input type="text" :disabled="readOnly" v-model="reportObj.originPlace" :title="reportObj.originPlace"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--检验日期-->
                                    <FormItem :label="$t('processInspectionSearch.t10')">
                                        <Input type="text" disabled v-model="reportObj.checkedDate" :title="reportObj.checkedDate"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!--判定结果-->
                                    <!-- <FormItem :label="$t('processInspectionSearch.t42')">
                                        <Input type="text" disabled v-model="reportObj.checkedResult" :title="reportObj.checkedResult"/>
                                    </FormItem> -->
                                </Col>
                            </Row>
                        </Form>

                    </div>

                </div>
            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                <!--计量检验-->
                {{ $t('processInspectionSearch.t36') }}
                <div slot="content">
                    <div style="width:100%;overflow-x:auto;">
                        <table cellspacing="0" cellpadding="0" ref="tbody" border="0" class="table" :style="{'min-width': tableWidth + 'px', width: '100%'}">
                            <tr>
                                <th width="50">
                                    <!--项目类别-->
                                    <span>{{ $t('processInspectionSearch.t37') }}</span>
                                </th>
                                <th width="60">
                                    <!--项目名称-->
                                    <span>{{ $t('processInspectionSearch.t38') }}</span>
                                </th>
                                <th width="40">
                                    <!--单位-->
                                    <span>{{ $t('processInspectionSearch.t6') }}</span>
                                </th>
                                <th width="50">
                                    <!--特性分级-->
                                    <span>{{ $t('processInspectionSearch.t39') }}</span>
                                </th>
                                <th width="50">
                                    <!--检验工具-->
                                    <span>{{ $t('processInspectionSearch.t40') }}</span>
                                </th>
                                <th width="50">
                                    <!--检验水平-->
                                    <span>{{ $t('processInspectionSearch.t27') }}</span>
                                </th>
                                <th width="40">
                                    <!--样本数-->
                                    <span>{{ $t('processInspectionSearch.t41') }}</span>
                                </th>
                                <th width="60" align="center">
                                    <!--检验结果-->
                                    {{ $t('processInspectionSearch.t42') }}
                                </th>
                                <th width="40">
                                    <!--不良数-->
                                    <span>{{ $t('processInspectionSearch.t43') }}</span>
                                </th>
                                <th width="40">
                                    <!--最小值-->
                                    <span>{{ $t('processInspectionSearch.t44') }}</span>
                                </th>
                                <th width="40">
                                    <!--最大值-->
                                    <span>{{ $t('processInspectionSearch.t45') }}</span>
                                </th>
                                <th width="40">
                                    <!--基准值-->
                                    <span>{{ $t('processInspectionSearch.t46') }}</span>
                                </th>
                                <th width="40" v-for="(i, key) in [1, 2, 3, 4, 5]" :key="key">
                                    <!--测量值-->
                                    <span>{{$t('processInspectionSearch.t47')}}{{ key + 1}}</span>
                                </th>
                                <th width="150">
                                    <span>{{ $t('processInspectionSearch.t48') }}</span>
                                </th>
                            </tr>
                            <tbody ref="tableTrBody1">
                                <tr v-for="(item, key) in reportObj.dtls"
                                    @click="trOnClick(key, '1')" :key="key" :ref="`tableTr1${key}`">
                                    <td>
                                        {{item.itemsCategoryTl}}
                                    </td>
                                    <td>
                                        {{item.itemsName}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyUom}}
                                    </td>
                                    <td>
                                        {{item.itemsLevel}}
                                    </td>
                                    <td>
                                        {{item.examinedTool}}
                                    </td>
                                    <td>
                                        {{item.inspectionLevelTl}}
                                    </td>
                                    <td>
                                        {{item.sampleQty}}
                                    </td>
                                    <td>
                                        <div style="padding:0 5px;">
                                            <Select placeholder="" v-model="item.checkedResult"
                                                    :disabled="readOnly"
                                                    :transfer="true"
                                                    @on-change="checkedResultChange($event, key, '')"
                                                    >
                                                <Option v-for="item2 in checkResultList2"
                                                        :value="item2.value"
                                                        :disabled="item2.value === 'OK'"
                                                        :key="item2.value">{{item2.label}}
                                                </Option>
                                            </Select>
                                        </div>
                                    </td>
                                    <td>
                                        {{item.ngQty}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyFloorTerms}}{{item.itemsPropertyFloor}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyCeilingTerms}}{{item.itemsPropertyCeiling}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyBenchmark}}
                                    </td>
                                    <td v-for="(i, key2) in 5" :key="key2">
                                            <!-- <td v-for="(item2, key2) in inputArrayList[key]" :key="key2"> -->
                                            <div v-if="key2 + 1 <= inputArrayList[key]">
                                                <Input
                                                        v-model="item.sampleMeteringCount[key2]"
                                                        :disabled="item.checkedResult === 'NA' || readOnly"
                                                        v-if="reLoad"
                                                        class="report-input number-input"
                                                        @on-blur="sampleMeteringOnChange(item, item.sampleMeteringCount[key2], key, key2, item.itemsPropertyFloorTerms, item.itemsPropertyCeilingTerms, true)"
                                                        @on-keydown="nextInput($event, key, key2)"
                                                >
                                                </Input>
                                                <span v-show="!reLoad">-</span>
                                            </div>
                                            <div v-else style="text-align:center">-</div>
                                    </td>
                                    <td>
                                        {{item.examinedBasis}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                <!--计数检验-->
                {{ $t('processInspectionSearch.t49') }}
                <div slot="content">
                    <table cellspacing="0" cellpadding="0" ref="tbody" border="0" style="width: 100%;" class="table" :style="{'min-width': tableWidth + 'px'}">
                        <tr>
                            <th width="80">
                                <!--项目类别-->
                                {{ $t('processInspectionSearch.t37') }}
                            </th>
                            <th width="100">
                                <!--项目名称-->
                                {{ $t('processInspectionSearch.t38') }}
                            </th>
                            <th width="80">
                                <!--技术要求-->
                                {{ $t('processInspectionSearch.t50') }}
                            </th>
                            <th width="70">
                                <!--特性分级-->
                                {{ $t('processInspectionSearch.t39') }}
                            </th>
                            <th width="100">
                                <!--检验工具-->
                                {{ $t('processInspectionSearch.t40') }}
                            </th>
                            <th width="100">
                                <!--检验水平-->
                                {{ $t('processInspectionSearch.t27') }}
                            </th>
                            <th width="60">
                                <!--样本数-->
                                {{ $t('processInspectionSearch.t41') }}
                            </th>
                            <th width="70" align="center">
                                <!--检验结果-->
                                {{ $t('processInspectionSearch.t42') }}
                            </th>
                            <th width="60">
                                <!--缺陷数-->
                                {{ $t('processInspectionSearch.t51') }}
                            </th>
                            <th width="150">
                                <!--缺陷描述-->
                                {{ $t('processInspectionSearch.t52') }}
                            </th>
                            <th>
                                <!--备注-->
                                {{ $t('processInspectionSearch.t53') }}
                            </th>
                        </tr>
                        <tbody ref="tableTrBody2">
                            <tr v-for="(item, key) in this.reportObj.dtls2"
                                :key="key" :ref="`tableTr2${key}`"  @click="trOnClick(key, '2')">
                                <td>
                                    {{item.itemsCategoryTl}}
                                </td>
                                <td>
                                    {{item.itemsName}}
                                </td>
                                <td align="center">
                                    <Button style="width: 40px;" icon="eye" type="info" shape="circle" @click="showTechnicalDetal(item.technicalRequirement)"></Button>
                                </td>
                                <td>
                                    {{item.itemsLevel}}
                                </td>
                                <td>
                                    {{item.examinedTool}}
                                </td>
                                <td>
                                    {{item.inspectionLevelTl}}
                                </td>
                                <td>
                                    {{item.sampleQty}}
                                </td>
                                <td>
                                    <Select v-model="item.checkedResult"
                                            :disabled="readOnly"
                                            :transfer="true"
                                            @on-change="checkedResultChange($event, key, '2')"
                                    >
                                        <Option v-for="item2 in checkResultList2"
                                                :value="item2.value"
                                                :key="item2.value">{{item2.label}}
                                        </Option>
                                    </Select>
                                </td>
                                <td>
                                    <Input type="text"
                                           v-model="item.ngQty"
                                           :disabled="item.checkedResult === 'NA' || readOnly"
                                           @on-blur="ngqtyOnChange(item.ngQty, key)"/>
                                </td>
                                <td>
                                    <Input type="text" v-model="item.ngInfo"
                                                       :disabled="item.checkedResult === 'NA' || readOnly"/>
                                </td>
                                <td>
                                    <Input type="text" v-model="item.remark" :disabled="readOnly"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;">
                {{ $t('processInspectionSearch.t54') }}
                <div slot="content">
                    <Upload
                        multiple
                        :show-upload-list="false"
                        :format="fileTypeList"
                        :max-size="10240"
                        ref="appendFile_ref"
                        :before-upload="handleBeforeUpload"
                        :on-error="errorUpload"
                        :on-success="successUpload"
                        :on-format-error="onFormatError"
                        :on-remove="removeFile"
                        :action="uploadFileUrl"
                        :on-exceeded-size="onExceededSize"
                        v-if="!readOnly && uploadFileIds.length < 9"
                    >
                        <Button type="ghost" icon="ios-cloud-upload-outline" :loading="loading">{{ $t('processInspectionSearch.t55') }}
                        </Button>
                    </Upload>
                    <ul>
                        <li style="margin-top:10px" v-for="(item, key) in uploadFileIds" :key="key">
                            {{item.fileName}} 
                            <Button type="primary" size="small" style="margin-right:10px;" @click="fileDownLoad(item.fileId, item.isQms)">{{$t('common.download')}}</Button>
                            <Button v-if="!readOnly" type="error" size="small" style="margin-right:10px;" @click="deleteFile(item.fileId)">{{ $t('common.delBtn') }}</Button>
                        </li>
                    </ul>
                    <div style="line-height:30px;color:red;">{{ $t('processInspectionSearch.t112') }}</div> <!--仅允许上传最多9份文件，文件大小不能超过10M-->
                </div>
            </custom-panel>
        </div>
    </div>
</template>

<script>
import CustomPanel from '@/components/awesome/page/panel/index';
import axios from 'axios';
import moment from 'moment';

export default {
    components: {
        CustomPanel,
    },
    props: {
        readOnly: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            createPoDtoList: [],
            reportObj: {
                id: '',
                reportNumber: '',
                buId: '',
                buName: '',
                itemCode: '',
                itemDesc: '',
                itemUnit: '',
                batchNumber: '',
                checker: '',
                checkCount: '',
                matchCount: '',
                usableCount: '',
                validStartTime: '',
                validEndTime: '',
                originPlace: '',
                divDesc: '',
                commonStandardsName: '',
                supplierName: '',
                supplierDesc: '',
                specialStandardsName: '',
                inspectionLevel: '',
                examinedStringency: '',
                checkedResultTl: '',
                onetimePurchaseFlagTl: '',
                trialFlagTl: '',
                sampleQty: '',
                dtls: [],
                dtls2: [],
                groupFlag: '',
            },
            reportRules: {
                checker: [
                    {
                        required: true, message: this.$t('processInspectionSearch.t64'), trigger: 'change',
                    },
                ],
                batchNumber: [
                    {
                        required: true, message: this.$t('processInspectionSearch.t65'), trigger: 'change',
                    },
                ],
                originPlace: [
                    {
                        required: true, message: this.$t('processInspectionSearch.t66'), trigger: 'change',
                    },
                ],
            },
            loading: false,
            fileTypeList: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', '7z', 'rar', 'zip'],
            uploadFileUrl: '/gscint/supplierfile/uploadFile',
            inputArray: [],
            inputArrayList: [],
            checkResultList2: [
                { value: 'OK', label: 'OK' },
                { value: 'NG', label: 'NG' },
            ],
            tableWidth: 1000,
            uploadFileIds: [],
            reLoad: true,
            CUX_INT_QMS_REPORT_NG_ORG: [],
        };
    },
    methods: {
        reportSubmit() {
            this.$refs.reportForm.validate((valid) => {
                if (valid) {
                    let hasNull = false;
                    this.reportObj.dtls.map((item) => {
                        const sampleQty = item.sampleQty >= 5 ? 5 : item.sampleQty;
                        if (item.checkedResult !== 'NA') {
                            item.sampleMeteringCount.map((item2, key) => {
                                if (!item2 && key <= sampleQty - 1) {
                                    hasNull = true;
                                }
                            });
                        }
                    });
                    if (hasNull) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('processInspectionSearch.t67'),
                        });
                        return false;
                    }
                    let cannotSubmit = false;
                    const newList = this.reportObj.dtls.concat(this.reportObj.dtls2);
                    if (this.checkResultList2.find((item) => item.value === 'NA')) {
                        if (newList.find((item) => item.checkedResult === 'NG')) {
                            cannotSubmit = true;
                        }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (newList.find((item) => item.checkedResult !== 'OK')) {
                            cannotSubmit = true;
                        }
                    }
                    /* 根据字段判断是否允许判断结果为NG的单据提交 */
                    if (cannotSubmit && !this.CUX_INT_QMS_REPORT_NG_ORG.some((item) => item.code === this.reportObj.orgCode)) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('processInspectionSearch.t68'), // 判定结果=不合格，不允许提交
                        });
                        return false;
                    }
                    this.loading = true;
                    const array = [];
                    this.reportObj.dtls.map((item) => {
                        array.push({
                            ...item,
                            sampleMeteringCount: undefined,
                            checkedData: item.sampleMeteringCount.join(),
                        });
                    });
                    const dtls = array.concat(this.reportObj.dtls2);
                    const soucre = this.$route.query.source;
                    const {
                        barcodeNumber, batchNumber, originPlace, buId, buName, checkCount, checker, itemCode, itemDesc, itemUnit, validEndTime, validStartTime, groupFlag, poLineIds, orgCode, orgId, checkedDate,
                    } = this.reportObj;
                    axios.post('/gscint/inspectionReport/saveReport', {
                        vendorCode: this.vendorCode,
                        batchNumber: soucre ? barcodeNumber : batchNumber,
                        orgCode,
                        orgId,
                        checkDate: checkedDate,
                        originPlace,
                        buId,
                        buName,
                        checkCount,
                        checker,
                        createdBy: this.vendorCode,
                        itemCode,
                        itemDesc,
                        itemUnit,
                        requestId: new Date().getTime(),
                        validEndTime: moment(validEndTime).format('YYYY-MM-DD 23:59:59'),
                        validStartTime: moment(validStartTime).format('YYYY-MM-DD 00:00:00'),
                        poLineIds,
                        linesDto: {
                            ...this.reportObj,
                            ...this.reportObjCopy,
                            checker,
                            originPlace,
                            dtls,
                            files: this.uploadFileIds,
                            groupFlag,
                        },
                        source: this.$route.query.source,
                        createPoDtoList: this.createPoDtoList,
                    })
                        .then((res) => {
                            this.loading = false;
                            if (res.data.data.code === '-1') {
                                this.showErrorTips();
                                return false;
                            // eslint-disable-next-line no-else-return
                            } else if (res.data.data.code === '1') {
                                this.$Modal.success({
                                    content: this.$t('processInspectionSearch.t69'),
                                });
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'processInspectionSearch',
                                    });
                                }, 2000);
                                setTimeout(() => {
                                    this.$closeTab({
                                        name: 'processInspectionEdit',
                                    });
                                }, 0);
                            } else {
                                this.showErrorTips('loading', res.data.data.msg);
                            }
                        })
                        .catch(() => {
                            this.showErrorTips();
                        });
                }
            });
        },
        queryReportLines(reportNumber) {
            axios.post('/gscint/inspectionReport/queryReportLines', {
                reportNumber,
            })
                .then((res) => {
                    const data = res.data.data.datas[0];
                    this.setData(data);
                });
        },
        qmsCreatedReportByOrg(data) {
            this.loading = true;
            axios.post('/gscint/inspectionReport/qmsCreatedReportByOrg', {
                ...data,
                vendorCode: this.vendorCode,
                queryLocal: '0',
            })
                .then((res) => {
                    this.loading = false;
                    const { code, datas, msg } = res.data.data;
                    if (code === '1') {
                        this.setData(datas);
                    } else {
                        this.showErrorTips('loading', msg);
                        setTimeout(() => {
                            this.$closeTab({
                                name: 'processInspectionEdit',
                            });
                        }, 2000);
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        setData(data) {
            // for (let i in this.reportObj) {
            //     if (this.readOnly) {
            //         this.reportObj[i] = data.header[i] ? data.header[i] : data[i];
            //     }
            //     // try {
            //     //     if (this.readOnly) {
            //     //         this.reportObj[i] = data.header[i] ? data.header[i] : data[i];
            //     //     } else {
            //     //         if (data[i]) {
            //     //             this.reportObj[i] = data[i];
            //     //         }
            //     //     }
            //     // } catch (err) {
            //     //     console.log(err);
            //     // }
            // }
            const newData = {
                ...data,
                ...data.header,
            };
            // eslint-disable-next-line no-restricted-syntax
            for (const i in newData) {
                if (newData[i]) {
                    this.reportObj[i] = newData[i];
                }
            }
            // const { orgCode, orgId } = this.reportObj;
            // this.reportObj = {
            //     ...this.reportObj,
            //     ...data,
            //     ...data.header,
            //     orgCode,
            //     orgId,
            // };
            // poNumber,
            // batchNo,
            // checker,
            if (this.readOnly) {
                const { poNumber, batchNo, checker, checkDate } = this.$route.params;
                const readObj = {
                    supplierDesc: JSON.parse(localStorage.getItem('supplierInfo')).vendorName,
                    poInfos: poNumber,
                    batchNumber: batchNo,
                    checker,
                    checkedDate: checkDate,
                };
                // eslint-disable-next-line no-restricted-syntax
                for (const i in readObj) {
                    if (!this.reportObj[i]) {
                        this.reportObj[i] = readObj[i];
                    }
                }
                /* 检验日期转换 */
                const { checkedDate } = this.reportObj;
                this.reportObj.checkedDate = checkedDate ? moment(checkedDate).format('YYYY-MM-DD HH:mm:ss') : '';
            }
            // const { batchQty, poLineIds } = this.$route.query;
            // this.reportObj.checkCount = batchQty;
            // this.reportObj.poLineIds = poLineIds;
            // this.reportObjCopy = JSON.parse(JSON.stringify(data));
            this.reportObj.dtls = data.dtls.filter((item) => item.itemsProperty === 'Metering');
            this.reportObj.dtls2 = data.dtls.filter((item) => item.itemsProperty !== 'Metering');
            this.reportObj.dtls.map((item) => {
                this.inputArrayList.push(item.sampleQty > 5 ? 5 : item.sampleQty);
            });
            if (this.inputArrayList.length > 0) {
                this.inputArray = Array(Math.max(...this.inputArrayList));
            }
            this.reportObj.dtls.map((item, index) => {
                let newArray = [];
                if (!this.readOnly) {
                    // this.inputArrayList[index]  this.inputArray.length
                    for (let i = 0; i < this.inputArrayList[index]; i++) {
                        newArray.push('');
                    }
                } else {
                    try {
                        newArray = this.reportObj.dtls[index].checkedData.split(',');
                    } catch (err) {
                        console.log('error', err);
                    }
                }
                this.reportObj.dtls[index].sampleMeteringCount = newArray;
            });
            this.tableWidth = 710 + 40 * (this.inputArray.length + 1);
            if (!this.readOnly) {
                this.reportObj.dtls2.map((item, index) => {
                    this.reportObj.dtls2[index].checkedResult = 'OK';
                });
            }
            this.uploadFileIds = data.files || [];
            if (this.readOnly) {
                this.reportObj.divDesc = data.header.buName;
            }
        },
        back() {
            this.$router.push({
                name: this.readOnly ? 'processInspectionSearch' : 'processInspectionAdd',
            });
        },
        // 检验结果
        checkedResultChange(val, key, type) {
            // this[`reportObj.dtls${type}`]
            const arr = this.reportObj[`dtls${type}`][key].sampleMeteringCount;
            if (val === 'NA') {
                const newArray = [];
                arr.map((item, index) => {
                    newArray.push('');
                });
                this.reportObj[`dtls${type}`][key].sampleMeteringCount = newArray;
                this.reLoad = false;
                setTimeout(() => {
                    this.reLoad = true;
                }, 0);
            }
            if (val === 'OK' && type === '2') {
                this.reportObj[`dtls${type}`][key].ngQty = 0;
            }
        },
        // 测量值修改
        sampleMeteringOnChange(row, val, trIndex, tdIndex, itemsPropertyFloorTerms, itemsPropertyCeilingTerms, isShowTips) {
            let isError = false;
            const numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
            if (!isNaN(val) && numberRule.test(val)) {
                if (!this.returnCompare(itemsPropertyFloorTerms, val, row.itemsPropertyFloor) || !this.returnCompare(itemsPropertyCeilingTerms, val, row.itemsPropertyCeiling)) {
                    if (isShowTips) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('processInspectionSearch.t60'),
                        });
                    }
                    isError = true;
                }
            } else {
                if (isShowTips) {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('processInspectionSearch.t61'),
                    });
                }
                isError = true;
            }
            if (isError) {
                if (isShowTips) {
                    this.reportObj.dtls[trIndex].checkedResult = 'NG';
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (isShowTips) {
                    let allOk = true;
                    let isTrue = true;
                    this.reportObj.dtls[trIndex].sampleMeteringCount.map((item) => {
                        const val2 = !this.sampleMeteringOnChange(row, item, trIndex, tdIndex, itemsPropertyFloorTerms, itemsPropertyCeilingTerms, false);
                        if (!val2) {
                            allOk = false;
                        }
                        if (this.reportObj.dtls[trIndex].sampleMeteringCount[0] !== item) {
                            isTrue = false;
                        }
                    });
                    if (allOk) {
                        this.reportObj.dtls[trIndex].checkedResult = 'OK';
                    }
                    if (this.reportObj.dtls[trIndex].sampleQty > 1 && isTrue) {
                        this.$Modal.warning({
                            title: this.$t('common.warn'),
                            content: this.$t('processInspectionSearch.t62'),
                        });
                    }
                }
            }
            return isError;
        },
        // 键盘按键
        nextInput(event, trIndex, tdIndex) {
            // 38 40
            let index = tdIndex;
            for (let i = 0; i < trIndex; i++) {
                index += this.inputArrayList[i];
            }
            const doms = document.getElementsByClassName('number-input');
            let newIndex;
            if (event.keyCode === 38) {
                if (doms[index - 1]) {
                    const dom = this.inputFocus(index - 1, doms);
                    dom.focus();
                }
            } else if (event.keyCode === 40 || event.keyCode === 13) {
                if (doms[index + 1]) {
                    const dom = this.inputFocus(index + 1, doms);
                    dom.focus();
                }
            }
        },
        trOnClick(rowIndex, type) {
            this.trBackgroundChange(type, rowIndex);
        },
        // 行选中修改颜色
        trBackgroundChange(tableIndx, rowIndex) {
            const tableTrs = this.$refs[`tableTrBody${tableIndx}`].children;
            for (const i in tableTrs) {
                for (const j in tableTrs[i].children) {
                    try {
                        tableTrs[i].children[j].style.background = '#FFF';
                    } catch (err) {
                        // console.log(err);
                    }
                }
            }
            for (const i in this.$refs[`tableTr${tableIndx}${rowIndex}`][0].children) {
                try {
                    this.$refs[`tableTr${tableIndx}${rowIndex}`][0].children[i].style.background = '#88c1f4';
                } catch (err) {
                    // console.log(err);
                }
            }
        },
        // 对比数据结果 （根据qms返回的校验规则来指定比较方案）
        returnCompare(PROPERTY, inputVal, minOrMax) {
            let flag = true;
            inputVal = parseFloat(inputVal);
            minOrMax = parseFloat(minOrMax);
            if (minOrMax || minOrMax === 0) {
                if (PROPERTY === '＞') {
                    flag = inputVal > minOrMax;
                } else if (PROPERTY === '≥') {
                    flag = inputVal >= minOrMax;
                } else if (PROPERTY === '＜') {
                    flag = inputVal < minOrMax;
                } else if (PROPERTY === '≤') {
                    flag = inputVal <= minOrMax;
                }
            } else {
                flag = true;
            }
            return flag;
        },
        // 缺陷数修改
        ngqtyOnChange(val, trIndex) {
            if (!isNaN(val) && val >= 0) {
                if (val > 0) {
                    this.reportObj.dtls2[trIndex].checkedResult = 'NG';
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('processInspectionSearch.t60'),
                    });
                }
            } else {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('processInspectionSearch.t63'),
                });
                this.reportObj.dtls2[trIndex].checkedResult = '';
                this.reportObj.dtls2[trIndex].ngQty = '';
            }
        },
        handleBeforeUpload() {
            this.loading = true;
        },
        onFormatError() {
            this.loading = false;
            this.$Modal.error({
                content: `${this.$t('processInspectionSearch.t122')}${this.fileTypeList.join()}${this.$t('processInspectionSearch.t123')}`, // 附件只支持XXX格式
            });
        },
        removeFile(file) {
            this.uploadFileIds = this.uploadFileIds.find((item) => item.fileId !== file.response.data.docId) || [];
        },
        onExceededSize() {
            this.loading = false;
            debugger;
            this.$Modal.error({
                content: this.$t('processInspectionSearch.t120'), // 上传的附件大于10M，请更换
            });
        },
        errorUpload() {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('processInspectionSearch.t121'), // 上传失败，请稍后再试
            });
        },
        successUpload(response, file) {
            this.loading = false;
            this.uploadFileIds.push({
                fileId: response.data.docId,
                fileName: response.data.fileName,
                fileSize: file.size,
            });
        },
        init() {
            const {
                selection, orgId, orgCode,
            } = this.$route.params;
            const {
                reportNumber
            } = this.$route.query;
            if (this.readOnly) {
                this.queryReportLines(reportNumber);
            } else {
                // eslint-disable-next-line no-lonely-if
                if (orgId) {
                    let batchQty = 0;
                    let poInfos = [];
                    let poLineIds = [];
                    selection.forEach((item) => {
                        batchQty += Number(item.checkQuantity);
                        poInfos.push(`${item.poNumber}-${item.poLineNumber}`);
                        poLineIds.push(item.poLineId);
                    });
                    this.createPoDtoList = selection.map(({ poNumber, poLineNumber, poQuantity, poNeedByDate, poLineId, checkQuantity, }) => {
                        return {
                            poNumber,
                            poLineNumber,
                            poQuantity,
                            poNeedByDate,
                            poLineId,
                            checkQuantity,
                        };
                    });
                    this.reportObj.orgCode = orgCode;
                    this.reportObj.orgId = orgId;
                    this.reportObj.poInfos = poInfos.join();
                    this.reportObj.checkCount = batchQty;
                    this.reportObj.poLineIds = poLineIds.join();
                    this.reportObj.itemUnit = selection[0].itemUnit;
                    this.qmsCreatedReportByOrg({
                        itemCode: selection[0].itemCode,
                        orgId,
                        orgCode,
                        batchQty,
                    });
                } else {
                    /*  页面已失效，请重新勾选数据 */
                    this.$Modal.error({
                        content: this.$t('processInspectionSearch.t95'),
                        onOk: () => {
                            this.$closeTab({
                                name: 'processInspectionEdit',
                            });
                        },
                        onCancel: () => {
                            this.$closeTab({
                                name: 'processInspectionEdit',
                            });
                        },
                    });
                }
            }
        },
        // 附件下载
        fileDownLoad(docId, isQms = false) {
            if (!isQms) {
                window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
            } else {
                window.open(`//${this.isPro() ? 'apiprod.midea.com' : 'apiuat.midea.com'}/qms/qms-api/meixin/DownloadFile?id=${docId}`);
            }
        },
        deleteFile(id) {
            this.$Modal.confirm({
                content: this.$t('processInspectionSearch.t124'), // 确定要删除附件吗？
                onOk: () => {
                    this.uploadFileIds = this.uploadFileIds.filter((item) => item.fileId !== id);
                },
            });
        },
    },
    activated() {
        this.init();
    },
    mounted() {
        /* 控制是否允许不合格提交 */
        this.getDict('CUX_INT_QMS_REPORT_NG_ORG');
        this.init();
    },
};

</script>
<style lang="less" scoped>
.layout {
    background: #FFF;
}
.title-bar {
    background-color: #F2F2F2;
    border: 1px solid #dddee1;
    padding: 10px 20px;
    button {
        float: right;
    }
    span {
        border-left: 5px solid #3AA2EB;
        padding: 0 7px;
        font-size: 15px;
        font-weight: 400;
        height: 32px;
        line-height: 32px;
    }
}
.table {
    th, td{
        height: 50px;
        background: #f8f8f9;
        padding: 0 5px;
        border: 1px solid #e9eaec;
    }
    td {
        background: #FFF;
        word-wrap: break-word;
        white-space: normal;
        word-break: break-all;
    }
}
</style>
